import axios from '@/axios'





const oldbeltnew = {
  //老带新主页
  async getOldbeltnewIndex(params) {
    return await axios.post('/uc/oldLeadNewActivity/getMyActivity', params)
  },
  //老带新--邀请奖励
  async invitationReward(params) {
    return await axios.post('/uc/oldLeadNewActivity/getInviteReward', params)
  },
  //老带新--被邀请奖励
  async invitedReward(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBeInviteReward', params)
  },
  //老带新--结算记录
  async getSettlementRecord(params) {
    return await axios.post('/uc/oldLeadNewActivity/getSettlementRecord', params)
  },
  //邀请--奖励详情
  async getInvitDetail(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBeInviteRewardInfo', params)
  },
  //绑定邀请码
  async bindInvitedCode(params) {
    return await axios.post('/uc/oldLeadNewActivity/getBindingAgentId', params)
  }
};

export default oldbeltnew;


// WEBPACK FOOTER //
// ./src/api/oldbeltnew.js